import { css } from '@linaria/core'
import { colors } from '@fs/zion-ui'

export default css`
  --_field: ${colors.gray03};
  --_lines: ${colors.gray100};

  [data-light] & {
    --_field: ${colors.gray100};
    --_lines: ${colors.gray02};
  }
  [data-white] & {
    --_field: ${colors.white90};
    --_lines: rgb(
      32,
      33,
      33
    ); //Because white theme converts all 'colors.ts' grays to whites, we are using a non-'colors' value
  }
`
